<template>
  <v-menu
      bottom
      left
      :close-on-content-click="false"
      v-if="!!pageProperties && !!pageProperties.lines"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn dark icon v-bind="attrs" v-on="on">
        <v-icon>mdi-dots-horizontal</v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <span v-for="(item, i) in pageProperties.lines" :key="i">
        <v-list-item dense @click="launchAction(item)"
                     :disabled="oneBlockAction || item.status !== null || !selectedItemList || disabled">
          <v-list-item-avatar>
            <span v-if="!!item.avatar_emoji">{{ item.avatar_emoji }}</span>
            <v-icon v-if="!!item.avatar_icon">{{ item.avatar_icon }}</v-icon>
          </v-list-item-avatar>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
          <v-list-item-action>
          <v-btn icon>
            <v-icon>{{ item.action_icon }}</v-icon>
          </v-btn>
        </v-list-item-action>
        </v-list-item>
        <v-divider v-if="item.line_type === 'divider'"></v-divider>
      </span>
    </v-list>
  </v-menu>
</template>

<script>
import commonFunction from '@/commonFunction/commonFunction'
import {v4 as uuidv4} from "uuid";
import draggable from "vuedraggable";
import BaseDeleteIcon from "@/components/Base/BaseDeleteIcon";
import BaseConfirmBtn from "@/components/Base/BaseConfirmBtn";
import BaseConfirmIcon from "@/components/Base/BaseConfirmIcon";

export default {
  name: 'BasePageMenu',
  props: {
    pageProperties: {default: null},
    fetchAction: {default: null},
    currentItem: {default: null},
    selectedItemList: {default: []},
    disabled: {default: false},
  },

  components: {},

  computed: {},

  watch: {
    pageProperties: {
      handler(newValue, oldValue) {
        this.oneBlockAction = !!(!!newValue && !!newValue.lines && newValue.lines.some((row) => row.status !== null));
      },
      deep: true
    }
  }
,

methods: {
  launchAction(actionItem)
  {
    console.log('launchAction', actionItem, this.currentItem, this.selectedItemList)
    this.oneBlockAction = true
    let selected_uid_list = []
    this.selectedItemList.forEach(row => selected_uid_list.push(row.uid))
    let dto_search = {
      current_uid: this.currentItem,
      selected_uid_list: selected_uid_list,
    }
    if (!!this.fetchAction) {
      this.fetchAction({dto: dto_search, dto_action_model: actionItem.action_model})
      actionItem.status = 'running'
      this.$emit('update:selectedItemList', [])
    }
  }
,
}
,

mounted()
{
}
,

data()
{
  return {
    item: null,
    oneBlockAction: false,
  }
}
}
</script>

<style scoped lang="scss">

</style>

<i18n>
{
  "en": {
    "lock_page": "Lock page",
    "show_deleted": "Show deleted"
  },
  "de": {
    "lock_page": "Seite sperren",
    "show_deleted": "Sendung gelöscht"
  }
}

</i18n>

